import React, { useState } from "react";
import { FaUserMd, FaMinus, FaPlus, FaHeartbeat, FaNotesMedical, FaCapsules, FaMicroscope, FaDna, FaChartLine,FaFlask, FaVial, FaFileMedical } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcarePLS/Bio.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        title: "Genetic Engineering & CRISPR Research",
        description: "Developing revolutionary gene-editing technologies to modify DNA sequences with precision. CRISPR-based therapies are being explored for treating genetic disorders, cancer, and rare diseases by correcting mutations at the molecular level. Researchers also investigate ethical considerations, delivery methods, and regulatory pathways for implementing gene-editing in clinical practice."
    },
    {
        title: "Molecular & Cellular Biology",
        description: "Studying the fundamental processes of cells to design innovative treatments and enhance drug delivery systems. This field explores cell signaling, protein interactions, and metabolic pathways to understand disease mechanisms and develop targeted therapies for conditions such as cancer, neurodegenerative disorders, and infectious diseases."
    },
    {
        title: "Biopharmaceutical Development",
        description: "Creating next-generation biologic drugs, including monoclonal antibodies, recombinant proteins, and gene-based therapies. Biopharmaceuticals play a crucial role in treating chronic diseases, autoimmune disorders, and rare genetic conditions. This field also focuses on optimizing bioprocessing techniques, improving drug stability, and ensuring regulatory compliance for market approval."
    },
    {
        title: "Regenerative Medicine",
        description: "Advancing stem cell research and tissue engineering to repair or replace damaged tissues and organs. Scientists explore techniques such as 3D bioprinting, organoid development, and induced pluripotent stem cells (iPSCs) to create functional tissues for transplantation and regenerative therapies aimed at conditions like spinal cord injuries, heart disease, and degenerative disorders."
    },
    {
        title: "Bioinformatics & Computational Biology",
        description: "Harnessing artificial intelligence (AI) and big data analytics to decode genomic information and drive personalized medicine. This field integrates computational tools, machine learning, and statistical models to analyze genetic variations, predict disease susceptibility, and optimize drug discovery. Bioinformatics is essential for precision medicine, vaccine development, and synthetic biology advancements."
    },
    {
        title: "Clinical Biotechnology Consulting",
        description: "Providing expert guidance on biopharmaceutical development, regulatory compliance, and market strategies. Clinical biotechnology consultants work with biotech firms, healthcare organizations, and regulatory agencies to navigate clinical trial design, ensure compliance with FDA and EMA guidelines, and develop strategies for commercialization and global market access."
    }
];
const features = [
    { icon: <FaDna className="text-[#2a627a] text-lg" />, text: "Innovative genetic engineering and genome editing techniques." },
    { icon: <FaMicroscope className="text-[#2a627a] text-lg" />, text: "Cutting-edge research in synthetic biology and molecular medicine." },
    { icon: <FaFlask className="text-[#2a627a] text-lg" />, text: "Development of biopharmaceuticals, vaccines, and biologics." },
    { icon: <FaVial className="text-[#2a627a] text-lg" />, text: "Advanced tissue engineering and regenerative medicine applications." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Personalized medicine and targeted drug therapies." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Biotechnology-driven diagnostics for early disease detection." }
];

const benefits = [
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Revolutionizes disease treatment with precision medicine." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Enhances patient care through advanced biopharmaceuticals." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Drives innovation in medical technology and diagnostics." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Develops novel treatments for genetic and rare diseases." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Improves the effectiveness of existing drugs with biotechnology advancements." },
    { icon: <FaDna className="text-[#2a627a] text-lg" />, text: "Advances gene therapy and regenerative medicine solutions." }
];
const cmsFeatures = [
    {
        icon: <FaUserMd className="text-[#2a627a] text-lg" />,
        title: "Biotechnology Research Scientist",
        text: "Conducts research on genetic engineering, molecular biology, and advanced biopharmaceuticals."
    },
    {
        icon: <FaMicroscope className="text-[#2a627a] text-lg" />,
        title: "Molecular Biologist",
        text: "Studies the molecular and cellular processes to develop targeted therapies."
    },
    {
        icon: <FaFlask className="text-[#2a627a] text-lg" />,
        title: "Biomedical Engineer",
        text: "Designs and develops bio-based technologies, including medical devices and synthetic biology applications."
    },
    {
        icon: <FaFileMedical className="text-[#2a627a] text-lg" />,
        title: "Clinical Biotechnologist",
        text: "Translates biotechnological research into clinical applications and therapeutic innovations."
    }
];
const BiotechnologyResearch = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Biotechnology Research - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Advancing scientific discovery in biological systems to develop transformative therapies and breakthrough healthcare innovations."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Biotechnology Research?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Biotechnology research involves the use of biological systems, organisms, and molecular processes to develop
                            innovative medical treatments, drugs, and diagnostic tools. At HIKEHEALTH GS, we leverage cutting-edge
                            biotechnological advancements to drive breakthroughs in personalized medicine, gene therapy, and regenerative
                            healthcare. Our research focuses on improving patient outcomes through science-driven innovation and ethical
                            medical practices.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Biotechnology Research
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default BiotechnologyResearch;
